import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { guaranteesStepNavigationStyles } from './styles.ts';
import type {
  TGuaranteesStepNavigationConfigItem,
  TGuaranteesStepNavigationItem,
} from './types.ts';

export const canActivateGuaranteesStep = (item: TGuaranteesStepNavigationItem) =>
  Boolean(item.onClick) && !item.disabled && item.status !== 'process';

export const getGuaranteesStepLabelStyles =
  (isClickable: boolean) =>
  (theme: Theme): SystemStyleObject<Theme> => ({
    ...guaranteesStepNavigationStyles.stepLabel(theme),
    ...(isClickable ? guaranteesStepNavigationStyles.clickableStepLabel(theme) : {}),
  });

export const getGuaranteesStepIconStyles =
  (isPending?: boolean) =>
  (theme: Theme): SystemStyleObject<Theme> => ({
    ...guaranteesStepNavigationStyles.stepIcon(theme),
    ...(isPending ? guaranteesStepNavigationStyles.pendingStepIcon : {}),
  });

export const buildGuaranteesStepItems = <TKey extends string>({
  currentStepKey,
  items,
  onStepClick,
}: {
  currentStepKey: TKey;
  items: ReadonlyArray<TGuaranteesStepNavigationConfigItem<TKey>>;
  onStepClick?: (stepKey: TKey) => void;
}): TGuaranteesStepNavigationItem<TKey>[] => {
  const currentIndex = items.findIndex(({ key }) => key === currentStepKey);

  return items.map((step, index) => ({
    key: step.key,
    title: step.title,
    disabled: step.disabled,
    status:
      step.key === currentStepKey
        ? 'process'
        : currentIndex !== -1 && index < currentIndex
          ? 'finish'
          : 'wait',
    ariaLabel: `Перейти до кроку: ${step.title}`,
    onClick: onStepClick ? () => onStepClick(step.key) : undefined,
  }));
};
